enum CalendarViewType {
  GridView,
  ListView,
}

export default CalendarViewType
